<template>
  <div>
    <BatteryForm></BatteryForm>
  </div>
</template>

<script>
import BatteryForm from "@/components/Batteries/BatteryForm/index.vue";
export default {
  components: {
    BatteryForm,
  },
};
</script>

<style></style>
